<!--<div class="inputcontainer {{ container_class }}" *ecertDisplay="action_identifier; id: id; iconY: '15px'">-->
<div class="inputcontainer {{ container_class }}">
  <label *ngIf="showActionIdentifier() && !hideLabel" [ngClass]="{ error: error }">
    {{ action_identifier | promptvalue | async
    }}<span [class.visible]="verplicht" [class.hidden]="!verplicht" style="color: #ff0000; padding-left: 3px">*</span></label
  >
  <ng-container *ngIf="!!ref_object && !!property">
    <ng-container *ngIf="disabled && inline; then gebruikTekst; else gebruikInput"></ng-container>
    <ng-template #gebruikTekst>
      {{ getWaarde() | ecertFormat: { datum: true } | async }}
    </ng-template>
    <ng-template #gebruikInput>
      <mat-form-field floatLabel="always">
        <input
          #input
          id="{{ id }}-input"
          matInput
          [matDatepicker]="picker"
          type="text"
          class="input"
          [ngClass]="{ error: error }"
          [class.wijzigbaar]="wijzigbaar"
          placeholder="{{ placeholder }}"
          [(ngModel)]="ref_object[property]"
          (dateChange)="onDateChange($event, input.value)"
          (input)="rauweInput($event)"
          [disabled]="disabled"
          [min]="minDate"
          [max]="maxDate"
          [maxlength]="action_identifier | lengthValue | async"
          [title]="tooltip"
        />
        <mat-datepicker-toggle matSuffix [for]="picker" *ngIf="showIcon()" class="hidden-if-disabled">
          <mat-icon matDatepickerToggleIcon></mat-icon>
        </mat-datepicker-toggle>
        <mat-datepicker #picker [calendarHeaderComponent]="dateHeader"></mat-datepicker>
      </mat-form-field>
    </ng-template>
  </ng-container>

  <div
    *ngIf="error"
    id="foutmelding"
    class="d-flex no-top-margin"
    [ngClass]="{ 'line-height-1': !foutmeldingSmal, 'multiple-lines': foutmeldingSmal }"
  >
    <ecert-icon class="mr-2" name="ui-alert" [canHover]="false" width="20px"></ecert-icon>
    <span class="font-italic pt-1" [ngClass]="{ 'pt-2': foutmeldingSmal }"> {{ foutmelding | promptvalue | async }}</span>
  </div>
</div>
